import { Dropdown, Space } from 'antd';
import { useContext } from 'react';
import { LibraryContext } from './context-provider';
import FolderColorPalette from './folder-color-palette';

export default function FolderContextMenu({ children, trigger, permission }) {
   const { setDeleteModalOpen, setRenameModalOpen, setMoveModalOpen, setShareModalOpen } = useContext(LibraryContext);
   const colors = [
      '#ff4d4f',
      '#ff7a45',
      '#ffa940',
      '#ffc53d',
      '#73d13d',
      '#36cfc9',
      '#40a9ff',
      '#597ef7',
      '#9254de',
      '#f759ab',
   ];

   const menu = [
      {
         key: 'rename',
         label: 'Rename',
         icon: <i className="fi fi-rr-pen-square" />,
         disabled: !permission || permission === 'read',
         onClick: () => setRenameModalOpen(true),
      },
      {
         key: 'color',
         label: (
            <Space direction="horizontal" style={{ width: '100%' }} size={4}>
               <i className="fi fi-rr-palette" />
               Folder color
            </Space>
         ),
         children: [
            {
               key: 'colorpalette',
               label: <FolderColorPalette />,
            },
         ],
         disabled: !permission || permission === 'read',
      },
      {
         label: 'Move to',
         icon: <i className="fi fi-rr-move-to-folder" />,
         disabled: !permission || permission === 'read',
         onClick: () => setMoveModalOpen(true),
      },
      {
         label: 'Share',
         icon: <i className="fi fi-rr-share" />,
         disabled: !permission || permission === 'read',
         onClick: () => setShareModalOpen(true),
      },
      {
         label: 'Delete',
         icon: <i className="fi fi-rr-trash" />,
         disabled: !permission || permission === 'read',
         onClick: () => setDeleteModalOpen(true),
      },
   ];

   return (
      <>
         <Dropdown
            trigger={trigger}
            menu={{
               items: menu,
               style: {
                  width: '180px',
               },
               expandIcon: <></>,
            }}
            placement="bottomRight"
         >
            {children}
         </Dropdown>
      </>
   );
}
